module.exports = __webpack_public_path__ + "static/media/background.1b119d7f.jpg";